import { Component } from '@angular/core';
import { AngularFireDatabase} from 'angularfire2/database';
import { Subject } from 'rxjs/Subject';
import "rxjs/add/operator/map";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts